import React from 'react';
export const Footer = () => {
  return <footer className="bg-aspira-navy text-white py-8" data-id="element-52">
      <div className="container mx-auto px-4 md:px-6" data-id="element-53">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-54">
          <div className="mb-4 md:mb-0" data-id="element-55">
            <p className="text-aspira-white opacity-70" data-id="element-56">
              Strategies for Growth and Success
            </p>
          </div>
          <div className="flex flex-row space-x-6 items-center" data-id="element-57">
            <a href="#about" className="text-aspira-white hover:text-aspira-green transition-colors" data-id="element-58">
              About
            </a>
            <a href="#services" className="text-aspira-white hover:text-aspira-green transition-colors" data-id="element-59">
              Services
            </a>
            <a href="#contact" className="text-aspira-white hover:text-aspira-green transition-colors" data-id="element-60">
              Contact
            </a>
          </div>
        </div>
        <div className="border-t border-white border-opacity-10 mt-6 pt-6 flex flex-col md:flex-row justify-between items-center" data-id="element-61">
          <p className="text-aspira-white opacity-70 text-sm" data-id="element-62">
            &copy; {new Date().getFullYear()} Aspira Works. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0" data-id="element-63">
            <a href="mailto:hello@aspiraworks.com" className="text-aspira-white opacity-70 hover:text-aspira-green text-sm transition-colors" data-id="element-64">
              hello@aspiraworks.com
            </a>
          </div>
        </div>
      </div>
    </footer>;
};